import * as React from 'react';

interface Props {
    fillColor?: string;
    heightWidth?: string;
}

const SvgLotusOpaque: React.FC<Props> = (props) => {
    const fillColor = props.fillColor || '#fff';
    const heightWidth = props.heightWidth || '1rem';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 645.56 461.9"
            width={heightWidth}
            height={heightWidth}
            {...props}
        >
            <defs>
                <style>{`.Lotus_Opaque_svg__cls-1{
                    fill:${fillColor}}`}</style>
            </defs>
            <g id="Lotus_Opaque_svg__Layer_2" data-name="Layer 2">
                <g id="Lotus_Opaque_svg__artwork">
                    <g id="Lotus_Opaque_svg__Group_400" data-name="Group 400">
                        <path
                            id="Lotus_Opaque_svg__Path_98"
                            data-name="Path 98"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M645.56 273.12C611.5 431 507.12 500.24 346.61 440.76a369.45 369.45 0 0036.73-37.08c87.55-21.24 146.45-61.09 175.09-118.49a173.84 173.84 0 0012.46-33.25 374.13 374.13 0 0174.67 21.18"
                        />
                        <path
                            id="Lotus_Opaque_svg__Path_99"
                            data-name="Path 99"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M262.21 403.66c-87.54-21.22-146.46-61.08-175.08-118.47a172.27 172.27 0 01-12.46-33.25A373.92 373.92 0 000 273.11C34.06 431 138.43 500.23 299 440.75a368.6 368.6 0 01-36.74-37.09"
                        />
                        <path
                            id="Lotus_Opaque_svg__Path_100"
                            data-name="Path 100"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M398.15 384.74c159.39-46 200.12-161 134.08-306.16-59.57 14.91-106.09 39-137.53 71.31 28.72 39.18 43.5 80.11 43.3 120.92-.19 39.18-13.56 77.29-39.86 113.94"
                        />
                        <path
                            id="Lotus_Opaque_svg__Path_101"
                            data-name="Path 101"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M313.28 85l9.5-7.87 9.5 7.87a381.81 381.81 0 0153.47 53.34 220.2 220.2 0 0126.62-22.64c-15-40-45.3-79-89.59-115.66-44.31 36.65-74.6 75.65-89.59 115.66a219.34 219.34 0 0126.61 22.6A381.88 381.88 0 01313.28 85"
                        />
                        <path
                            id="Lotus_Opaque_svg__Path_102"
                            data-name="Path 102"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M250.85 149.89c-31.44-32.35-78-56.4-137.53-71.31C47.28 223.79 88 338.74 247.4 384.74c-26.29-36.65-39.67-74.74-39.86-113.94-.2-40.82 14.59-81.73 43.31-120.91"
                        />
                        <path
                            id="Lotus_Opaque_svg__Path_103"
                            data-name="Path 103"
                            className="Lotus_Opaque_svg__cls-1"
                            d="M322.78 441.83C462 328.92 451.51 202.52 322.78 96c-128.73 106.51-139.18 232.91 0 345.82"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default SvgLotusOpaque;
